module.exports = __webpack_public_path__ + "img/flutter.7ff1e9b7.png";